import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y1979 = new LunarYear(
  moment.tz('1979-01-28 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 6, 6, 7, 8, 9, 10, 11, 12],
  [30, 29, 29, 30, 29, 30, 30, 29, 30, 30, 29, 30, 29],
  6,
)

export default Y1979
